import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {BonusBunniesGameConfig} from "../../BonusBunniesGameConfig";
import {FullScreenClicker} from "@nolimitcity/slot-game/bin/core/component/FullScreenClicker";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {Linear, TimelineLite, TweenLite} from "gsap";
import {BonusBunniesGameModuleConfig} from "../../BonusBunniesGameModuleConfig";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";

/**
 * Created by Jerker Nord on 2019-09-04.
 */

export class BonusBunniesBottomRowWPView extends BaseView {

    private _extraRow4:PIXI.Sprite;
    private _extraRow5:PIXI.Sprite;
    private _presentationLayer:ScalableLayer;
    private _presentationContainer:PIXI.Container;
    private _spineExtraRowPresentation:PIXI.spine.Spine;
    private _winAnimationTL:TimelineLite;
    private static EXTRA_ROW_POSITION:PIXI.Point = new PIXI.Point(10, 650);

    constructor() {
        super();
        StageManager.getLayer(BonusBunniesGameConfig.instance.LAYERS.REEL_BACKGROUND.name).addChild(this);
        this._presentationLayer = StageManager.getLayer(BonusBunniesGameConfig.instance.LAYERS.BIG_WIN.name);
        this._presentationContainer = new PIXI.Container;
        this._presentationContainer.visible = false;
        this._presentationLayer.addChild(this._presentationContainer);
    }

    protected initAnimations():void {
        this._spineExtraRowPresentation = new PIXI.spine.Spine(GameResources.getSpineAsset("SpineB4"));
        this._spineExtraRowPresentation.position.set(360, 360);
        this._presentationContainer.addChild(this._spineExtraRowPresentation);
        this._extraRow4 = new PIXI.Sprite(GameResources.getTextures("extraRow4Background")[0]);
        this._extraRow4.position = BonusBunniesBottomRowWPView.EXTRA_ROW_POSITION;
        this._extraRow4.visible = false;
        this.addChild(this._extraRow4);
        this._extraRow5 = new PIXI.Sprite(GameResources.getTextures("extraRow5Background")[0]);
        this._extraRow5.position = BonusBunniesBottomRowWPView.EXTRA_ROW_POSITION;
        this._extraRow5.visible = false;
        this.addChild(this._extraRow5);
    }

    public getWinAnimationTL(lastReelActivated:boolean):TimelineLite {
        if(this._winAnimationTL && this._winAnimationTL.isActive()) {
            this._winAnimationTL.pause();
            this._winAnimationTL.kill();
        }
        this._winAnimationTL = new TimelineLite();
        this._winAnimationTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesBonusGameInfoPlate.disableInfo());
        this._winAnimationTL.add(() => this._presentationContainer.visible = true);
        this._winAnimationTL.add(() => this._presentationContainer.alpha = 1);
        this._winAnimationTL.add(() => this._spineExtraRowPresentation.state.setAnimation(0, "trigger", false));
        this._winAnimationTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesBonusGameInfoPlate.set5RowPosition());
        if (lastReelActivated == true){
            this._winAnimationTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesBonusGameInfoPlate.setExtraReelPositionAndScale());
        }
        this._winAnimationTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesBonusGameInfoPlate.enableInfo(), "+=1");
        this._winAnimationTL.add(new TweenLite(this._presentationContainer, 0.2, {
            alpha : 0,
            ease : Linear.easeNone
        }), "+=1");

        return this._winAnimationTL;
    }

    public abortWinAnimation():void {
        if(this._winAnimationTL && this._winAnimationTL.isActive()) {
            this._winAnimationTL.pause();
            this._winAnimationTL.kill();
        }
        this._presentationContainer.visible = false;
    }

    public enableExtra4Row():void {
        this._extraRow4.visible = true;
        BonusBunniesGameModuleConfig.bonusBunniesReelAreaView.extraRow4GridContainer.visible = true;
    }

    public abortEnableExtra4Row():void {
        this._extraRow4.visible = true;
        BonusBunniesGameModuleConfig.bonusBunniesReelAreaView.extraRow4GridContainer.visible = true;
    }

    public enableExtra5Row():void {
        this._extraRow4.visible = false;
        BonusBunniesGameModuleConfig.bonusBunniesReelAreaView.extraRow4GridContainer.visible = false;
        this._extraRow5.visible = true;
        BonusBunniesGameModuleConfig.bonusBunniesReelAreaView.extraRow5GridContainer.visible = true;
    }

    public abortEnableExtra5Row():void {
        this._extraRow4.visible = false;
        BonusBunniesGameModuleConfig.bonusBunniesReelAreaView.extraRow4GridContainer.visible = false;
        this._extraRow5.visible = true;
        BonusBunniesGameModuleConfig.bonusBunniesReelAreaView.extraRow5GridContainer.visible = true;
    }

    public disableExtraRow():void {
        this._extraRow4.visible = false;
        this._extraRow5.visible = false;
        BonusBunniesGameModuleConfig.bonusBunniesReelAreaView.extraRow4GridContainer.visible = false;
        BonusBunniesGameModuleConfig.bonusBunniesReelAreaView.extraRow5GridContainer.visible = false;
    }
}